import React from 'react'
import heartsmall from '../../assets/heartsmall.png'

export default function Cart(props) {
  const context = props.context
  const cart = context.cart


  const handleDelete = function (id) {
    context.actions.removeItem(id)
  }

  return (
        <div className="forms-container">
            {cart.length > 0 ? (
              <div className="cart-form">
                {cart.map((item, index) =>{
                  return (
                    <div className={`cart-item-${index + 1}`} key={index}>
                      <div className="item-image">
                        <img src={heartsmall} width="60" height="52" alt="Heart Small" />
                      </div>
                      <div className="item-name-desc-container">
                        <div className="item-name">
                          {item.name}
                        </div>
                        <div className="item-desc">
                          {item.description}
                        </div>
                      </div>
                      <div className="item-price">
                        ${item.price}.00
                      </div>
                      <div className="item-delete">
                        <button id="delete" title="Delete" onClick={(e) => {handleDelete(index)}}>X</button>
                      </div>
                  </div>
                  )
                })}
              </div>
            ):(
              <div className="cart-form-empty">No items in your cart</div>
            )}
        </div>
  )
}